/**
 * Provider for custom attribute
 * @module
 */

var _ = require('optimizely-client-fn');
var enums = require('core/constants/enums');
var Logger = require('core/utils/logger');

var di = require('core/di');
var DimensionDataStore = di.get('stores/dimension_data');

module.exports = {
  provides: 'custom',
  attributionType: enums.AttributionTypes.LAST_TOUCH,

  // NB. no "getter" defined; see v1.user for how value is set

  /**
   * Enrich attributes set through API before creation in app by pulling id value from DimensionData store
   * @param {Object.<Object>} value
   * @returns {Object.<Object>}
   */
  restorer: function(value:Record<string, any>): Record<string, any> {
    return _.reduce(value, function(res, val, key) {
      var newKey = key;
      var apiNameAttr = DimensionDataStore.getByApiName(key);
      var idAttr = DimensionDataStore.getById(key);
      var matchingAttr = idAttr;

      if (!_.isObject(val)) {
        // Value set prior to 602b25 and/or shoved into the store through some other means. Drop these values.
        Logger.error('Unable to restore custom attribute "' + key + '" because value is not an object');
        return res;
      }
      if (!val.id && !!apiNameAttr) {
        // Enriching a previously unknown attribute (set by apiName)
        matchingAttr = apiNameAttr;
        newKey = apiNameAttr.id;
        _.extend(val, {
          id: matchingAttr.segmentId || matchingAttr.id,
        });
      }
      if (!val.name) {
        // Enrich the existing value with the name of the matching attribute
        if (matchingAttr && matchingAttr.apiName) {
          val.name = matchingAttr.apiName;
        }
      }
      if (!val.id && !matchingAttr) {
        // If val is an object with an id property, don't warn - could have been loaded by different snippet
        Logger.warn('Unable to determine ID for custom attribute:', key, '; segmentation is disabled.');
      }

      res[newKey] = val;
      return res;
    }, {});
  },

  shouldTrack: true,
};
